import type { User } from "@/types";

interface SessionIdentity {
  sessionEpoch: number;
  isAuthenticated: boolean;
  user: User | null;
}

/** Public identities only. Tokens, names and report data never become cache keys. */
export function authRequestIdentity(state: SessionIdentity): string {
  return JSON.stringify([
    state.sessionEpoch,
    state.isAuthenticated,
    state.user?.tenantId ?? null,
    state.user?.id ?? null,
  ]);
}

export function authCacheIdentity(state: SessionIdentity): string {
  return JSON.stringify([
    authRequestIdentity(state),
    state.user?.role ?? null,
    state.user?.roleId ?? null,
    [...new Set(state.user?.permissions ?? [])].sort(),
    Object.entries(state.user?.moduleAccess ?? {}).sort(([a], [b]) =>
      a.localeCompare(b),
    ),
    state.user?.mustResetPassword ?? false,
  ]);
}
